<template>
    <section class="detail_section">
        <v-form ref="form" v-model="valid" v-if="!loading">
            <v-row class="detail_wrapper">
                <v-col v-if="!showIframe && !showWarnings" cols="12" class="deny_header">
                    <div class="top_icon">
                        <svg version="1.1" height="100" :fill="preScoring.Scoring.color" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <g> <g> <path d="M418.998,498.791l-25.075-73.998c-1.375-4.06-5.185-6.791-9.471-6.791h-1.455v-145.01 c0-70.026-56.97-126.997-126.997-126.997s-126.997,56.97-126.997,126.997v145.01h-1.455c-4.286,0-8.096,2.731-9.471,6.791 l-25.074,73.998c-1.035,3.053-0.534,6.416,1.344,9.036c1.878,2.619,4.903,4.173,8.127,4.173h307.053 c3.224,0,6.249-1.554,8.127-4.173C419.532,505.207,420.033,501.844,418.998,498.791z M149.003,272.993 c0-58.998,47.999-106.997,106.997-106.997c58.998,0,106.997,47.999,106.997,106.997v145.01H149.003V272.993z M116.421,492.001 l18.297-53.998h242.563l18.298,53.998H116.421z"/> </g> </g> <g> <g> <path d="M256,0c-5.522,0-10,4.478-10,10v59.999c0,5.522,4.477,10,10,10c5.522,0,10-4.478,10-10V10C266,4.478,261.522,0,256,0z"/> </g> </g> <g> <g> <path d="M263.069,101.884c-1.859-1.86-4.439-2.92-7.069-2.92s-5.21,1.06-7.07,2.92c-1.86,1.87-2.93,4.439-2.93,7.08 c0,2.63,1.069,5.2,2.93,7.07c1.86,1.859,4.44,2.92,7.07,2.92s5.21-1.061,7.069-2.92c1.86-1.87,2.931-4.44,2.931-7.07 C266,106.323,264.93,103.754,263.069,101.884z"/> </g> </g> <g> <g> <path d="M95.504,267.66H49.587c-5.522,0-10,4.478-10,10s4.478,10,10,10h45.918c5.522,0,10-4.478,10-10 S101.026,267.66,95.504,267.66z"/> </g> </g> <g> <g> <path d="M17.076,270.59c-1.859-1.861-4.439-2.93-7.069-2.93s-5.21,1.069-7.07,2.93c-1.86,1.861-2.93,4.44-2.93,7.07 s1.069,5.21,2.93,7.069c1.86,1.86,4.44,2.931,7.07,2.931s5.21-1.07,7.069-2.931c1.86-1.859,2.931-4.439,2.931-7.069 S18.936,272.45,17.076,270.59z"/> </g> </g> <g> <g> <path d="M188.673,88.988l-13.554-32.721c-2.114-5.102-7.963-7.521-13.066-5.412c-5.103,2.114-7.525,7.964-5.412,13.066 l13.554,32.721c1.596,3.851,5.319,6.176,9.243,6.176c1.275,0,2.571-0.246,3.823-0.764 C188.364,99.939,190.786,94.089,188.673,88.988z"/> </g> </g> <g> <g> <path d="M74.981,191.855L42.26,178.301c-5.104-2.108-10.952,0.311-13.066,5.412c-2.113,5.103,0.31,10.952,5.412,13.066 l32.721,13.554c1.252,0.517,2.548,0.764,3.823,0.764c3.924,0,7.647-2.325,9.243-6.176 C82.506,199.818,80.083,193.969,74.981,191.855z"/> </g> </g> <g> <g> <path d="M466.58,267.66h-45.918c-5.522,0-10,4.478-10,10s4.478,10,10,10h45.918c5.522,0,10-4.478,10-10 S472.102,267.66,466.58,267.66z"/> </g> </g> <g> <g> <path d="M509.062,270.59c-1.859-1.86-4.439-2.93-7.069-2.93s-5.21,1.069-7.07,2.93s-2.93,4.44-2.93,7.07s1.069,5.21,2.93,7.069 c1.86,1.86,4.44,2.931,7.07,2.931s5.21-1.07,7.069-2.931c1.86-1.859,2.931-4.439,2.931-7.069S510.923,272.45,509.062,270.59z"/> </g> </g> <g> <g> <path d="M453.748,79.909c-3.906-3.904-10.236-3.904-14.143,0l-49.203,49.204c-3.905,3.905-3.905,10.237,0,14.143 c1.954,1.953,4.513,2.929,7.072,2.929c2.56,0,5.118-0.977,7.071-2.929l49.203-49.204 C457.652,90.147,457.652,83.815,453.748,79.909z"/> </g> </g> <g> <g> <path d="M121.596,129.113L72.393,79.911c-3.906-3.904-10.236-3.904-14.143,0c-3.905,3.905-3.905,10.237,0,14.143l49.204,49.203 c1.953,1.952,4.512,2.929,7.071,2.929c2.559,0,5.118-0.977,7.071-2.929C125.501,139.351,125.501,133.019,121.596,129.113z"/> </g> </g> <g> <g> <path d="M349.945,50.855c-5.103-2.108-10.952,0.311-13.066,5.412l-13.554,32.721c-2.113,5.102,0.31,10.951,5.412,13.066 c1.252,0.518,2.548,0.764,3.823,0.764c3.924,0,7.647-2.325,9.243-6.176l13.554-32.721 C357.47,58.817,355.047,52.969,349.945,50.855z"/> </g> </g> <g> <g> <path d="M482.805,183.713c-2.114-5.103-7.963-7.522-13.066-5.412l-32.721,13.554c-5.103,2.114-7.525,7.964-5.412,13.066 c1.596,3.851,5.319,6.176,9.243,6.176c1.275,0,2.571-0.246,3.823-0.764l32.721-13.554 C482.496,194.665,484.918,188.815,482.805,183.713z"/> </g> </g> <g> <g> <path d="M256,209.008c-16.542,0-29.999,13.458-29.999,29.999v47.999c0,16.542,13.458,29.999,29.999,29.999 s29.999-13.458,29.999-29.999v-47.999C285.999,222.466,272.542,209.008,256,209.008z M266,287.006c0,5.514-4.486,10-10,10 s-10-4.486-10-10v-47.999c0-5.514,4.486-10,10-10s10,4.486,10,10V287.006z"/> </g> </g> <g> <g> <path d="M256,337.005c-16.542,0-29.999,13.458-29.999,29.999c0,16.542,13.458,29.999,29.999,29.999s29.999-13.458,29.999-29.999 C285.999,350.462,272.542,337.005,256,337.005z M256,377.004c-5.514,0-10-4.486-10-10s4.486-10,10-10s10,4.486,10,10 S261.514,377.004,256,377.004z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
                    </div>
                    <v-row  class="d-flex justify-space-between">
                        <v-col cols=12 md=6>
                            <h1 class="header_title text-center text-md-left" :style="{color: preScoring.Scoring.color}" v-html="headerTitle"></h1>
                            <p class="header_subtitle">{{preScoring.Scoring.description}}</p>
                        </v-col>
                        <v-col cols=12 md=4 class="header_percent_info d-flex flex-column justify-center align-center">
                            <p :style="{color: preScoring.Scoring.color}" class="perc_title">% sobre valor de compra</p>
                            <p :style="{color: preScoring.Scoring.color}" class="percent">{{preScoring.Scoring.porcentaje_a_financiar}}% </p>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col v-if="showIframe || showWarnings" cols="12" class="deny_header">
                    <div class="top_icon">
                        <svg version="1.1" height="100" :fill="preScoringWarnings.color" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <g> <g> <path d="M418.998,498.791l-25.075-73.998c-1.375-4.06-5.185-6.791-9.471-6.791h-1.455v-145.01 c0-70.026-56.97-126.997-126.997-126.997s-126.997,56.97-126.997,126.997v145.01h-1.455c-4.286,0-8.096,2.731-9.471,6.791 l-25.074,73.998c-1.035,3.053-0.534,6.416,1.344,9.036c1.878,2.619,4.903,4.173,8.127,4.173h307.053 c3.224,0,6.249-1.554,8.127-4.173C419.532,505.207,420.033,501.844,418.998,498.791z M149.003,272.993 c0-58.998,47.999-106.997,106.997-106.997c58.998,0,106.997,47.999,106.997,106.997v145.01H149.003V272.993z M116.421,492.001 l18.297-53.998h242.563l18.298,53.998H116.421z"/> </g> </g> <g> <g> <path d="M256,0c-5.522,0-10,4.478-10,10v59.999c0,5.522,4.477,10,10,10c5.522,0,10-4.478,10-10V10C266,4.478,261.522,0,256,0z"/> </g> </g> <g> <g> <path d="M263.069,101.884c-1.859-1.86-4.439-2.92-7.069-2.92s-5.21,1.06-7.07,2.92c-1.86,1.87-2.93,4.439-2.93,7.08 c0,2.63,1.069,5.2,2.93,7.07c1.86,1.859,4.44,2.92,7.07,2.92s5.21-1.061,7.069-2.92c1.86-1.87,2.931-4.44,2.931-7.07 C266,106.323,264.93,103.754,263.069,101.884z"/> </g> </g> <g> <g> <path d="M95.504,267.66H49.587c-5.522,0-10,4.478-10,10s4.478,10,10,10h45.918c5.522,0,10-4.478,10-10 S101.026,267.66,95.504,267.66z"/> </g> </g> <g> <g> <path d="M17.076,270.59c-1.859-1.861-4.439-2.93-7.069-2.93s-5.21,1.069-7.07,2.93c-1.86,1.861-2.93,4.44-2.93,7.07 s1.069,5.21,2.93,7.069c1.86,1.86,4.44,2.931,7.07,2.931s5.21-1.07,7.069-2.931c1.86-1.859,2.931-4.439,2.931-7.069 S18.936,272.45,17.076,270.59z"/> </g> </g> <g> <g> <path d="M188.673,88.988l-13.554-32.721c-2.114-5.102-7.963-7.521-13.066-5.412c-5.103,2.114-7.525,7.964-5.412,13.066 l13.554,32.721c1.596,3.851,5.319,6.176,9.243,6.176c1.275,0,2.571-0.246,3.823-0.764 C188.364,99.939,190.786,94.089,188.673,88.988z"/> </g> </g> <g> <g> <path d="M74.981,191.855L42.26,178.301c-5.104-2.108-10.952,0.311-13.066,5.412c-2.113,5.103,0.31,10.952,5.412,13.066 l32.721,13.554c1.252,0.517,2.548,0.764,3.823,0.764c3.924,0,7.647-2.325,9.243-6.176 C82.506,199.818,80.083,193.969,74.981,191.855z"/> </g> </g> <g> <g> <path d="M466.58,267.66h-45.918c-5.522,0-10,4.478-10,10s4.478,10,10,10h45.918c5.522,0,10-4.478,10-10 S472.102,267.66,466.58,267.66z"/> </g> </g> <g> <g> <path d="M509.062,270.59c-1.859-1.86-4.439-2.93-7.069-2.93s-5.21,1.069-7.07,2.93s-2.93,4.44-2.93,7.07s1.069,5.21,2.93,7.069 c1.86,1.86,4.44,2.931,7.07,2.931s5.21-1.07,7.069-2.931c1.86-1.859,2.931-4.439,2.931-7.069S510.923,272.45,509.062,270.59z"/> </g> </g> <g> <g> <path d="M453.748,79.909c-3.906-3.904-10.236-3.904-14.143,0l-49.203,49.204c-3.905,3.905-3.905,10.237,0,14.143 c1.954,1.953,4.513,2.929,7.072,2.929c2.56,0,5.118-0.977,7.071-2.929l49.203-49.204 C457.652,90.147,457.652,83.815,453.748,79.909z"/> </g> </g> <g> <g> <path d="M121.596,129.113L72.393,79.911c-3.906-3.904-10.236-3.904-14.143,0c-3.905,3.905-3.905,10.237,0,14.143l49.204,49.203 c1.953,1.952,4.512,2.929,7.071,2.929c2.559,0,5.118-0.977,7.071-2.929C125.501,139.351,125.501,133.019,121.596,129.113z"/> </g> </g> <g> <g> <path d="M349.945,50.855c-5.103-2.108-10.952,0.311-13.066,5.412l-13.554,32.721c-2.113,5.102,0.31,10.951,5.412,13.066 c1.252,0.518,2.548,0.764,3.823,0.764c3.924,0,7.647-2.325,9.243-6.176l13.554-32.721 C357.47,58.817,355.047,52.969,349.945,50.855z"/> </g> </g> <g> <g> <path d="M482.805,183.713c-2.114-5.103-7.963-7.522-13.066-5.412l-32.721,13.554c-5.103,2.114-7.525,7.964-5.412,13.066 c1.596,3.851,5.319,6.176,9.243,6.176c1.275,0,2.571-0.246,3.823-0.764l32.721-13.554 C482.496,194.665,484.918,188.815,482.805,183.713z"/> </g> </g> <g> <g> <path d="M256,209.008c-16.542,0-29.999,13.458-29.999,29.999v47.999c0,16.542,13.458,29.999,29.999,29.999 s29.999-13.458,29.999-29.999v-47.999C285.999,222.466,272.542,209.008,256,209.008z M266,287.006c0,5.514-4.486,10-10,10 s-10-4.486-10-10v-47.999c0-5.514,4.486-10,10-10s10,4.486,10,10V287.006z"/> </g> </g> <g> <g> <path d="M256,337.005c-16.542,0-29.999,13.458-29.999,29.999c0,16.542,13.458,29.999,29.999,29.999s29.999-13.458,29.999-29.999 C285.999,350.462,272.542,337.005,256,337.005z M256,377.004c-5.514,0-10-4.486-10-10s4.486-10,10-10s10,4.486,10,10 S261.514,377.004,256,377.004z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
                    </div>
                    <v-row  class="d-flex justify-space-between">
                        <v-col cols=12 md=12>
                            <h1 class="header_title text-center text-md-left" :style="{color: preScoringWarnings.color}">{{preScoringWarnings.result}}</h1>
                        </v-col>
                       
                    </v-row>
                </v-col>
                
                <v-col cols="12" class="footer_blocks">
                    <div class="block">
                        <p class="title">{{valueLable}}</p>
                        <p class="value">{{preScoring.Scoring.valor_compra | currency}}</p>
                    </div>
                    <div class="block">
                        <p class="title">{{savingsLabel}}</p>
                        <p class="value">{{preScoring.Scoring.dinero_aportado | currency}}</p>
                    </div>
                    <div class="block">
                        <p class="title">Gastos en tu comunidad aut.</p>
                        <p class="value">{{preScoring.Scoring.gastos_en_tu_ccaa | currency}}</p>
                    </div>
                    <div class="block">
                        <p class="title">Importe a Financiar</p>
                        <p class="value">{{preScoring.Scoring.importe_a_financiar | currency}}</p>
                    </div>
                    <!-- <div class="block">
                        <p class="title">% sobre el valor de compra</p>
                        <p class="value">{{preScoring.Scoring.porcentaje_a_financiar}}%</p>
                    </div>
                    <div class="block">
                        <p class="title">Plazo</p>
                        <p class="value">{{preScoring.Scoring.variable_años}}Años</p>
                    </div> -->
                </v-col>

                <v-row v-if="!showIframe && !showWarnings" class="footer_info d-flex justify-space-between">
                    <v-col cols=12 md=6 class="footer_info_block footer_info_left">
                        <h2>¿Cuál es el motivo?</h2>
                        <div v-html="preScoring.Scoring.result_detail" style="color:#333" class="mt-3"></div>
                    </v-col>
                    <v-col cols=12 md=6 class="footer_info_block footer_info_right d-flex flex-column">
                        <h2 style="color:#2BD871">Ayúdanos a que tu operación sea viable</h2>
                        
                        <div class="d-flex flex-column align-start" v-if="!['liquidez','mejorar','ampliacion','extincion_condominio'].includes(preScoring.Vivienda.tipo_vivienda)">
                            <p>Si aumentas tu aportación tendrás más posibilidades de hacer viable la operación.</p>
                            <v-btn @click="openChangeDataModal('aportacion')" class="btn-viability-help">Aumentar tu aportación</v-btn>
                        </div>

                        <div class="d-flex flex-column align-start" v-if="['liquidez','mejorar','ampliacion','extincion_condominio'].includes(preScoring.Vivienda.tipo_vivienda)">
                            <p>Revisa y modifica los valores de tu solicitud.</p>
                            <v-btn @click="$router.push('view2')" class="btn-viability-help">Modificar</v-btn>
                        </div>

                        <div class="d-flex flex-column align-start" v-if="['compra_vivienda_100','2avivienda','extincion_condominio','autopromocion','cambio_vivienda'].includes(preScoring.Vivienda.tipo_vivienda)">
                            <template v-if="preScoring.Vivienda.tipo_vivienda === '2avivienda'">
                                <p>Si necesitas más del <strong>70% de financiación</strong> podemos darte soluciones pero tú nos tienes que ayudar!</p>
                                <p>Tienes que aportar Avalistas (con vivienda libre de Cargas)</p>
                                <p>Una empresa especializada en Hipotecas más del 70%, sin compromiso, te llamará</p>
                            </template>

                            <template v-if="preScoring.Vivienda.tipo_vivienda === 'liquidez'">
                                <p>Si necesitas más del <strong>80% de financiación</strong> podemos darte soluciones pero tú nos tienes que ayudar!</p>
                                <p>Tienes que aportar Avalistas (con vivienda libre de Cargas)</p>
                                <p>Una empresa especializada en Hipotecas más del 80%, sin compromiso, te llamará</p>
                            </template>
                            
                            <p v-if="!['2avivienda','liquidez'].includes(preScoring.Vivienda.tipo_vivienda)" >Si aportas aval tendrás más posibilidades de hacer viable la operación.</p>
                            <v-btn @click="openChangeDataModal('aval')" class="btn-viability-help">Aportar avalista</v-btn>
                        </div>

                        <div class="d-flex flex-column align-start" v-if="['habitual','compra_vivienda_100','2avivienda','extincion_condominio','autopromocion','cambio_vivienda'].includes(preScoring.Vivienda.tipo_vivienda)">
                            <p>No puedo aportar más ni aportar aval. Complementar con un préstamo personal</p>
                            <v-btn @click="openChangeDataModal('personal')" class="btn-viability-help">Préstamo personal</v-btn>
                        </div>
                    </v-col>
                </v-row>
                 <v-row v-if="showIframe && showWarnings" class="footer_info d-flex justify-space-between">
                     <v-col cols=12 md=6 class="footer_info_block footer_info_left">
                        <h2>¿Cuáles son los motivos?</h2>
                     </v-col>
                     <v-col cols=12 md=6 class="footer_info_block footer_info_left">
                        <h2 :style="{color: preScoringWarnings.color+'!important'}">Ayúdanos a que tu operación sea viable</h2>
                     </v-col>
                 </v-row>
                 <div v-if="showIframe || showWarnings">

                 
                <v-row v-for="(warning,index) in warnings" v-bind:key="index"  class="footer_info d-flex justify-space-between" style="border-bottom: solid 1px">
                    
                    
                    <v-col cols=12 md=6 class="footer_info_block footer_info_left">
                        <h2 style="color: #fb8c00"><v-icon style="color: #fb8c00"> mdi-alert </v-icon> {{warning[1].title}}</h2>
                        <div v-html="warning[1].message" style="color:#333" class="mt-3"></div>
                        <v-col v-if="warning[0]=='percent_to_finance'" cols=12 md=12 class="header_percent_info d-flex flex-column justify-center align-center">
                            <p :style="{color: preScoringWarnings.color+'!important'}" style="font-size:1.7em" class="perc_title">% sobre valor de compra</p>
                            <p :style="{color: preScoringWarnings.color+'!important'}" style="font-size:3em" class="percent">{{preScoringWarnings.calculation_result.percent_to_finance}}% </p>
                        </v-col>
                        <v-col v-if="warning[0]=='percent_of_debt'" cols=12 md=12 class="header_percent_info d-flex flex-column justify-center align-center">
                            <p :style="{color: preScoringWarnings.color+'!important'}" style="font-size:1.7em" class="perc_title">% de endeudamiento</p>
                            <p :style="{color: preScoringWarnings.color+'!important'}" style="font-size:3em" class="percent">{{preScoringWarnings.calculation_result.percent_of_debt}}% </p>
                        </v-col>
                    </v-col>
                    <v-col cols=12 md=6 class="footer_info_block footer_info_right d-flex flex-column">
                        
                        <div class="d-flex flex-column align-start" v-for="(solution,index) in warning[1].solutions" v-bind:key="index">
                            <p>{{solution.message}}</p>
                            <v-btn style="color: #fb8c00; border: 2px solid #fb8c00;" v-if="solution.type=='owner_savings'" @click="openChangeDataModal('aportacion')" class="btn-viability-help">Modificar tu aportación</v-btn>
                            <v-btn style="color: #fb8c00; border: 2px solid #fb8c00;" v-if="solution.type=='amount_requested'" @click="openChangeDataModal('amount_requested')" class="btn-viability-help">Modificar el valor de compra</v-btn>
                            <v-btn style="color: #fb8c00; border: 2px solid #fb8c00;" v-if="solution.type=='reinforcement'" @click="openChangeDataModal('aval')" class="btn-viability-help">Cambiar aval</v-btn>
                            <v-btn style="color: #fb8c00; border: 2px solid #fb8c00;" v-if="solution.type=='guarantor'" @click="openChangeDataModal('aval')" class="btn-viability-help">Aportar avalista</v-btn>  
                            <v-btn style="color: #fb8c00; border: 2px solid #fb8c00;" v-if="solution.type=='owner_debts'" @click="openChangeDataModal('deuda')" class="btn-viability-help">Modificar cuotas de deudas</v-btn>                            
                            <v-btn style="color: #fb8c00; border: 2px solid #fb8c00;" v-if="solution.type=='personal_loan'" @click="openChangeDataModal('personal')" class="btn-viability-help">Préstamo personal</v-btn>
                            <v-btn style="color: #fb8c00; border: 2px solid #fb8c00;" v-if="solution.type=='owner'" @click="openChangeDataModal('owner')" class="btn-viability-help">Añadir titular</v-btn>
                        </div>
                    </v-col>
                </v-row>
                <v-btn @click="$router.push('view3')" depressed class="blue_button error mt-10 ">Atras</v-btn>
                 <v-btn @click="cancel()" depressed class="blue_button error mt-10 align-end " style="float: right;" v-if="showIframe">Scoring Ko</v-btn>
                </div>
            </v-row>
        </v-form>
        <ChangeDataModal @send="saveChangeDataModal" @close="changeDataModalActive = false" :type="changeDataType" :dialog="changeDataModalActive"/>
    </section>
</template>

<script>
    import { mapState, mapMutations,mapActions } from 'vuex';
    import rulesMixin from '../../mixins/rulesMixin';
    import ChangeDataModal from './ChangeDataModal';

    export default {
        mixins: [rulesMixin],
        components:{
            ChangeDataModal
        },
        data() {
            return {
                valid: false,
                changeDataModalActive: false,
                changeDataType: null,
                warnings:[],
                showWarnings:false,
            }
        },
        props:['product'],
        computed: {
            ...mapState([
                'preScoring',
                'preScoringWarnings',
                'loading',
                'products',
                'showIframe',
                'deal_id',
            ]),
            headerTitle(){
                return `${this.preScoring.Scoring.result.replace('UPPS, LO SENTIMOS.' , '<strong style="font-size:2.3rem">UPPS, LO SENTIMOS.</strong><br>')}`;
            },
            productTitle(){
                if(this.preScoring && this.preScoring.Vivienda && this.preScoring.Vivienda.tipo_vivienda){
                    let index = this.products.map(product => product.type).indexOf(this.preScoring.Vivienda.tipo_vivienda);
                    return (index >= 0) ? this.products[index].title : '';
                }else{
                    return '';
                }
            },
            valueLable(){
                let label = 'Valor de compra';
                switch (this.preScoring.Vivienda.tipo_vivienda) {
                    case 'mejorar':
                    case 'ampliacion':
                        label = 'Valor de tasación';
                        break;
                }
                return label;
            },
            savingsLabel(){
                let label = 'Dinero aportado';
                switch (this.preScoring.Vivienda.tipo_vivienda) {
                    case 'mejorar':
                    case 'ampliacion':
                        label = 'Capital';
                        break;
                }
                return label;
            }
        },
        mounted() {
            if(this.preScoringWarnings){
              this.warnings = Object.entries(this.preScoringWarnings.warnings);
              this.showWarnings=true;
            }
          
           
        },
        methods: {
            ...mapActions([
                'callCancelDeal',
                
            ]),
            ...mapMutations([
                'SET_LOADING',
                'SET_ACTIVE_AVAL',
                'FREEZE_STATE',
                'SET_ACTIVE_PERSONAL_LOAN'
            ]),
            openChangeDataModal(type){
                // preScoring.Titulares.total_dinero_ahorrado
                this.FREEZE_STATE();
                this.changeDataModalActive = true;
                this.changeDataType = type;

                if(type === 'aval'){
                    this.SET_ACTIVE_AVAL(1);
                }
                if(type === 'personal'){
                    this.SET_ACTIVE_PERSONAL_LOAN('si');
                }
            },
            saveChangeDataModal(type){ 
                this.changeDataModalActive = false;
      
                this.$emit('reScoring', type);
            },
            cancel(){
                if(this.showIframe){
                        this.callCancelDeal(this.deal_id)
                        .then(response =>{
                             window.parent.location.href = 'https://helloteca.cloudframework.app/app.html#https://helloteca-com.web.app/vapps/helloteca_users.html?dealId='+this.deal_id+'&reload=true';
                            
                            
                        })
                    }
            }
        },
    }
</script>

<style lang="scss" scoped>
    $gray: #333;
    $succesColor: #2BD871;
    
    .detail_section{
        display: flex;
        flex-flow: column;
        align-items: center;
        padding: 50px 30px;
        box-sizing: border-box;
    }
    .detail_wrapper{
        width: 100%;
        max-width: 1150px;
        display: flex;
        flex-flow: column nowrap;
        .btn-viability-help{
            font-size: 1.2rem;
            font-weight: bold;
            padding: 10px 40px;
            border-radius: 5px;
            border: 2px solid $succesColor;
            color: $succesColor;
            transition: all .3s;
            background: #FFF !important;
            min-height: 52px;
            text-transform: initial;
            box-shadow: none;
            letter-spacing: initial;
            &:hover{
                transition: all .3s;
                background: $succesColor !important;
                color: #FFF !important;
            }
        }
        .deny_header{
            border-top: 1px solid #CCC;
            position: relative;
            margin-top: 50px;
            padding-top: 40px;
            box-sizing: border-box;
            .header_percent_info{
                .perc_title{
                    font-size: 1rem;
                    font-weight: 500;
                    margin-bottom: 0;
                }
                .percent{
                    font-size: 3rem;
                    font-weight: 700;
                }
            }
            .header_title{
                font-size: 2rem;
                line-height: 2.4rem;
            }
            .header_subtitle{
                font-size: .8rem;
                line-height: 1.2rem;
                color: $gray;
                margin-top: 10px;
            }
            .top_icon{
                position: absolute;
                top: 0;
                left: 50%;
                transform: translate(-50%, -60%);
                background: #FFF;
                padding: 10px 30px;
            }
        }
       
        .footer_blocks{
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 5px 0px;
            border-top: 1px solid #CCC;
            border-bottom: 1px solid #CCC;
            padding: 20px 0;
            @media (max-width: 690px) {
                display: flex;
                flex-flow: column nowrap;
            }
            .block{
                padding: 10px 15px;
                box-sizing: border-box;
                display: flex;
                flex-flow: row nowrap;
                font-family: 'montserrat';
                font-weight: bold;
                color: $gray;
                p{
                    font-size: .9rem !important;
                    line-height: 1.1rem !important;
                    margin: 0 !important;
                }
                .title{
                    margin-bottom: 15px;
                    width: 60%;
                }
                .value{
                    margin-bottom: 15px;
                    width: 40%;
                }
            }
        }
        .footer_info{
            padding-top: 30px;
            .footer_info_block{
                h2{
                    min-height: 50px;
                    margin-bottom: 20px;
                    line-height: 1.9rem;
                }
                > div{
                    margin-bottom: 50px;
                    &.big{
                        p{
                            font-size: 1.1rem;
                            line-height: 1.6rem;
                        }
                    }
                }
                &.footer_info_left{
                    padding-right: 60px;
                    box-sizing: border-box;
                    h4{
                        font-weight: 500;
                    }
                    p{
                        color: $gray !important;
                        font-size: 1.2em;
                        line-height: 1.8rem;
                    }
                }
                &.footer_info_right{
                    padding-left: 60px;
                    box-sizing: border-box;
                    @media (max-width: 960px) {
                        padding-left: 12px;
                    }
                    p{
                        color: #666;
                        font-size: .9rem;
                        line-height: 1.4rem;
                    }
                    strong{
                        font-weight: 700;
                    }
                }
            }
            
        }
    }

</style>